const graphs = {
    namespaced: true,
    state: {
        timePeriodSelected: 0,
        iceData: {
            live: [],
            settle: [],
            dates: []
        },
        fxData: {
            live: [],
            settle: [],
            dates: []
        },
        marketChangeSeriesData: {
            changes: [],
            times: []
        }
    },
    getters: {
        getTimePeriodSelected(state) {
            return state.timePeriodSelected
        },
        getIceData(state) {
            return state.iceData
        },
        getFxData(state) {
            return state.fxData
        }
    },
    mutations: {
        POPULATE_MARKET_CHANGE_SERIES_DATA: (state, payload) => {
            payload.forEach((dataSet, index) => {
                state.marketChangeSeriesData.times.splice(index, index + 1, dataSet[0])
                state.marketChangeSeriesData.changes.splice(index, index + 1, dataSet[1])
            })
        },
        SELECT_GRAPHS_TIME_PERIOD:(state, payload) => {
            state.timePeriodSelected = payload
        },
        POPULATE_ICE_LIVE: (state, payload) => {
            state.iceData.live = []
            state.iceData.dates = []

            payload.data.prices.forEach((data, index) => {
                state.iceData.live.splice(index, index + 1, data[1])
                state.iceData.dates.splice(index, index + 1, data[0])
            })
        },
        POPULATE_ICE_SETTLEMENT: (state, payload) => {
            state.iceData.settle = []
            
            /* If time period selected is within today, then append today's settlement price only */
            if (payload.query.period == '3H' || payload.query.period == '24H' || payload.query.period == '1D'){
                const settlement = payload.res.data.data.find(data => 
                    new Date(data[0]).toDateString() == new Date().toDateString())
                    
                if (settlement){
                    for (let i = 0; i < state.iceData.dates.length; i++){
                        state.iceData.settle.splice(i, i + 1, settlement[1])
                    }
                }
            }
            else {
                state.iceData.dates = []

                payload.res.data.data.forEach((data, index) => {
                    state.iceData.dates.splice(index, index + 1, data[0])
                    state.iceData.settle.splice(index, index + 1, data[1])
                })
            }
        },
        POPULATE_FX_LIVE: (state, payload) => {
            state.fxData.live = []
            state.fxData.dates = []

            payload.data.data.forEach((data, index) => {
                state.fxData.live.splice(index, index + 1, data[1])
                state.fxData.dates.splice(index, index + 1, data[0])
            })
        },
        POPULATE_FX_SETTLEMENT: (state, payload) => {
            state.fxData.settle = []
            
            /* Check time period selected, then decide how to populate settlement array */
            if (payload.period == '3D' || payload.period == '7D'){
                state.fxData.dates = []

                payload.res.data.data.forEach((data, index) => {
                    state.fxData.dates.splice(index, index + 1, data[0])
                    state.fxData.settle.splice(index, index + 1, data[1])
                })
            }
            else {
                state.fxData.live.forEach((data, index) => {
                    state.fxData.settle.splice(index, index + 1, payload.res.data.price)
                })
            }
        }
    },
    actions: {
        populateMarketChangeSeriesData: async ({commit, rootState}) => {
            const response = await rootState.axios.get('/api/getMarketChangeSeries')

            if (response.data.success){
                commit('POPULATE_MARKET_CHANGE_SERIES_DATA', response.data.results)
            }
        },
        selectGraphsTimePeriod: ({commit}, payload) => {
            commit("SELECT_GRAPHS_TIME_PERIOD", payload)
        },
        populateIceLive: ({commit, dispatch, rootState}, query) => {
            /* Fetch settlement prices instead if time period selected is greater than a day */
            if (query.period == '3H' || query.period == '24H' || query.period == '1D'){
                rootState.axios.get('/api/getDataICELive', {
                        params: {
                            period: query.period,
                            timeSplit: query.timeSplit
                        }})
                    .then((res)=>{
                        commit('POPULATE_ICE_LIVE', res)
                    })
                    .then(() => {
                        dispatch('populateIceSettlement', query)
                    })
                    .catch(error=> console.log('error ', error))
            }
            else {
                dispatch('populateIceSettlement', query)
            }
        },
        populateIceSettlement: ({commit, rootState}, query) => {
            rootState.axios.get('/api/getDataIceSettlement', {
                    params: {
                        /* If time period selected is within today, then fetch prices for the last 3 days */
                        period: query.period == '3H' || query.period == '24H' || query.period == '1D' ?
                            '3D' : query.period
                    }})
                .then((res) => {
                    const payload = {
                        res: res,
                        query: query 
                    }

                    commit('POPULATE_ICE_SETTLEMENT', payload)
                })
                .catch(error=> console.log('error ', error))
        },
        populateFxLive: ({commit, dispatch, rootState}, query) => {
            /* Fetch settlement prices instead if time period selected is greater than a day */
            if (query.period == '3H' || query.period == '24H' || query.period == '1D'){
                rootState.axios.get('/api/getDataFXLive', {
                        params: {
                            symbol: query.symbol,
                            period: query.period,
                            timeSplit: query.timeSplit
                        }})
                    .then((res)=>{
                        commit('POPULATE_FX_LIVE', res)
                    })
                    .then(() => {
                        dispatch('populateFxSettlement', query)
                    })
                    .catch(error=> console.log('error ', error))
            }
            else {
                dispatch('populateFxSettlement', query)
            }
        },
        populateFxSettlement: ({commit, rootState}, query) => {
            /* Check time period selected, then fetch data based on selected (today only or not) */
            if (query.period == '3D' || query.period == '7D'){
                rootState.axios.get('/api/getDataFxSettlement', {
                        params: {
                            symbol: '%23X.SGBPUSD',
                            period: query.period
                        }})
                    .then((res)=>{
                        const payload = {
                            period: query.period,
                            res: res
                        }

                        commit('POPULATE_FX_SETTLEMENT', payload)
                    })
                    .catch(error=> console.log('error ', error))
            }
            else {
                rootState.axios.get('/api/getDataFxSettlementTodayOnly', {
                        params: {
                            symbol: '%23X.SGBPUSD'
                        }})
                    .then((res)=>{
                        const payload = {
                            period: query.period,
                            res: res
                        }
                        
                        commit('POPULATE_FX_SETTLEMENT', payload)
                    })
                    .catch(error=> console.log('error ', error))
            }
        }
    }
}

export default graphs